import { queryOptions } from '@tanstack/react-query';
import { labsApi } from './labs.api';

export const labKeys = {
  all: ['labs'] as const
};

export const labQueries = {
  all: () =>
    queryOptions({
      queryKey: labKeys.all,
      queryFn: () => labsApi.getAll(),
      staleTime: 5 * 60 * 1000
    })
};
